import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { runConfigurationTemplateConfigTree } from '@api/configurationTemplates';

import { IDumpId } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IConfigurationTemplateTimestampsDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';

import { EUserRoles } from '@enums/common';

import {
	CONFIGURATION_TEMPLATES_CHECK_CONFIG_TREE,
	CONFIGURATION_TEMPLATES_RUN_CONFIG_TREE,
} from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesConfigTreeReturned {
	dumpId?: string;
	isLoadingRunConfigTree: boolean;
	runTree: UseMutateFunction<IDumpId, any, IConfigurationTemplateTimestampsDTO, any>;
}

const useMutateConfigurationRunTemplatesConfigTree = (): IUseQueryConfigurationTemplatesConfigTreeReturned => {
	const queryClient = useQueryClient();

	const {
		data,
		mutate: runTree,
		isLoading: isLoadingRunConfigTree,
	} = useMutation<IConfigurationTemplateTimestampsDTO<number>, IDumpId>({
		mutationKey: [CONFIGURATION_TEMPLATES_RUN_CONFIG_TREE],
		mutationFn: runConfigurationTemplateConfigTree,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess: () => {
			return queryClient.invalidateQueries([CONFIGURATION_TEMPLATES_CHECK_CONFIG_TREE]);
		},
	});

	return {
		dumpId: data?.dumpId,
		isLoadingRunConfigTree,
		runTree,
	};
};

export default useMutateConfigurationRunTemplatesConfigTree;
